import { Button } from "antd";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import ListExportTemplates from "../../components/admin/ListExportTemplates";
import PageTitle from "../../components/shared/PageTitle";
import { AppContext } from "../../context";
import { getParam } from "../../helper";

const Container = styled.div`
  max-width: 70%;
  margin-left: auto;
  margin-right: auto;
  @media screen and (max-width: 768px) {
    max-width: 100%;
  }
`;
export default class ExportTemplatesPage extends Component {
  render() {
    const { currentUser } = this.context;
    let param = getParam(currentUser);
    return (
      <Container>
        <PageTitle
          title="Export Templates"
          action={
            <Link to={`/${param}/manager-files/add-template`}>
              <Button type="primary">Add Export Template</Button>
            </Link>
          }
        />
        <ListExportTemplates />
      </Container>
    );
  }
}

ExportTemplatesPage.contextType = AppContext;
